/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartVaccinesDetailAliases {
  BUTTON_DOWNLOAD = 'button-download',
  BUTTON_EMAIL = 'button-email',
  CONTEXTUAL_BAR_VACCINE_DETAIL = 'contextual-bar-vaccine-detail',
  FIELD_ADVERSE_REACTION = 'field-adverse-reaction',
  FIELD_APPLICATION_DATE = 'field-application-date',
  FIELD_DOSE = 'field-dose',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_ESTIMED_DATE = 'field-estimed-date',
  FIELD_NEXT_DOSE_DATE = 'field-next-dose-date',
  FIELD_NOTES = 'field-notes',
  FIELD_STATUS = 'field-status',
  FIELD_VACCINE_NAME = 'field-vaccine-name',
  FORM_VACCINE = 'form-vaccine',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_APPLICATION_DATE = 'input-application-date',
  INPUT_ESTIMED_DATE = 'input-estimed-date',
  INPUT_NEXT_DOSE = 'input-next-dose',
  LAYOUT_VACCINE_DETAIL = 'layout-vaccine-detail',
  PANEL_VACCINE = 'panel-vaccine',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AREA_1 = 'text-area-1',
}
export { MyChartVaccinesDetailAliases };
